import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Task 
export const getDealStatusList = createAsyncThunk("DealRelated/get-list", async (data) => {
console.log("data in task master redux api", data)
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-deal-related-list`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({'respppppppppppppptaskMasterredux' :response })
        return response;
    } catch (error) {
        console.error('Error fetching Sites - ', error);
        throw error;
    }
})